import styled from "styled-components";

interface TabListStyleProps {
  $length?: number;
}

export const TabList = styled.ul<TabListStyleProps>`
  display: grid;
  grid-template-columns: repeat(${(props) => props.$length}, 1fr);
`;
